/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 20/07/2021 - 15:30:27
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 20/07/2021
    * - Author          :
    * - Modification    :
**/
import * as React from "react"

const KeyVetor = (props) => {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 5.156a5.156 5.156 0 01-6.118 5.067l-.703.791a.704.704 0 01-.526.236h-1.09v1.172a.703.703 0 01-.704.703H4.688v1.172a.703.703 0 01-.704.703H.704A.703.703 0 010 14.297V12.01c0-.187.074-.365.206-.497l4.74-4.74A5.156 5.156 0 019.843 0C12.7-.001 15 2.3 15 5.155zM9.844 3.75a1.406 1.406 0 102.812 0 1.406 1.406 0 00-2.812 0z"
        fill="#24A95D"
      />
    </svg>
  )
}

export default React.memo(KeyVetor)
